import { IconCheck, IconCopy } from '@tabler/icons-react'
import { useEffect, useRef, useState } from 'react'

/**
 * Menyalin nilai ke papan klip dengan umpan balik teks, bukan hanya perubahan
 * warna. Tombol tidak pernah menampilkan nilai lama: nilainya diberikan pemanggil
 * hanya selama dialog yang menampilkannya masih terbuka.
 */
export function CopyButton({
  value,
  label,
  small,
}: {
  value: string
  label: string
  small?: boolean
}) {
  const [copied, setCopied] = useState(false)
  const timer = useRef<number | undefined>(undefined)

  useEffect(() => {
    return () => {
      window.clearTimeout(timer.current)
    }
  }, [])

  async function copy() {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      window.clearTimeout(timer.current)
      timer.current = window.setTimeout(() => setCopied(false), 2000)
    } catch {
      setCopied(false)
    }
  }

  return (
    <button
      type="button"
      className={small ? 'btn btn--sm' : 'btn'}
      onClick={() => void copy()}
      aria-label={copied ? `${label}: tersalin` : label}
    >
      {copied ? (
        <IconCheck size={18} stroke={1.75} aria-hidden="true" />
      ) : (
        <IconCopy size={18} stroke={1.75} aria-hidden="true" />
      )}
      {copied ? 'Tersalin' : 'Salin'}
    </button>
  )
}
